<template>

    <rkm-tabs v-model="tabIndex">

        <rkm-tab
            title="Atendimento individual"
            v-if=" data.model.criaFichaAtendimentoIndividual"
        >
            <TabAtendimentoIndividual
                ref="atendimentoIndividual"
                :data="data"
                :pacienteId="pacienteId"
                :isAmbulatorio="true"
                @handleAtendimentoIndividual="handleAtendimentoIndividual"
                @saveAtendimentoIndividual="saveAtendimentoIndividual"
                @focusTabAtendimentoIndividual="focusTabAtendimentoIndividual"
            />
        </rkm-tab>

        <rkm-tab
            title="Atendimento odontológico"
            v-if="data.model.criaFichaAtendimentoOdontologico"
        >
            <TabAtendimentoOdontologico
                ref="atendimentoOdontologico"
                :data="data"
                :edit="false"
                :id="pacienteId"
                :isAmbulatorio="true"
                @handleAtendimentoOdontologico="handleAtendimentoOdontologico"
                @saveAtendimentoOdontologico="saveAtendimentoOdontologico"
                @focusTabAtendimentoOdontologico="focusTabAtendimentoOdontologico"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>

// Components.
import TabAtendimentoIndividual from '@/components/atencao-basica/atendimento-individual/Form'
import TabAtendimentoOdontologico from '@/components/atencao-basica/atendimento-odontologico/Form'

export default {
    components: {
        TabAtendimentoIndividual,
        TabAtendimentoOdontologico,
    },
    computed: {
        atendimentoModel() {
            return {
                ...this.procedimentos,
                paciente: {
                    id: this.pacienteId,
                    prontuario: this.data.model.prontuario,
                    cidadao: {
                        nome: this.data.model.cidadaoPacienteNome,
                        nomeSocial: this.cidadaoPacienteNomeSocial,
                        cns: this.data.model.cidadaoPacienteCns,
                        cpf: this.data.model.cidadaoPacienteCpf,
                        dataNascimento: this.data.model.cidadaoPacienteDataNascimento,
                        preferenciaNomeId: this.data.model.preferenciaNomeId,
                    }
                },
            };
        }
    },
    data: () => ({
        tabIndex: 0,
        procedimentos: {
            id: null,
            turnoId: null,
            microareaId: null,
            escutaInicial: null,
            localAtendimentoId: null,
            tipoAtendimentoId: null,
            perimetroCefalico: null,
            peso: null,
            altura: null,
            temperatura: null,
            vacinacao: null,
            afericaoPa: null,
            glicemia: null,
            exameLaboratorial: null,
            administracaoMedicamento: [],
            procedimentoPequenaCirurgia: [],
            testeRapido: [],
            procedimentos: [],
            procedimento: null,
            microarea: null,
            nomeSocial: null,
            preferenciaNomeId: null,
            paciente: {
                id: null,
                prontuario: null,
                cidadao: {
                    nome: null,
                    cns: null,
                    cpf: null,
                    dataNascimento: null,
                }
            }
        },
    }),
    methods: {
        focusTabAtendimentoIndividual() {

            this.tabIndex = 0
        },
        focusTabAtendimentoOdontologico() {

            this.tabIndex = 1
        },
        atendimentoIndividual() {

            return this.$refs.atendimentoIndividual.saveAmbulatorio()
        },
        atendimentoOdontologico() {

            return this.$refs.atendimentoOdontologico.saveAmbulatorio()
        },
        handleAtendimentoIndividual(value) {

            this.$emit('handleAtendimentoIndividual', value)
        },
        handleAtendimentoOdontologico(value) {

            this.$emit('handleAtendimentoOdontologico', value)
        },
        saveAtendimentoIndividual(value) {

            this.$emit('saveAtendimentoIndividual', value)
        },
        saveAtendimentoOdontologico(value) {

            this.$emit('saveAtendimentoOdontologico', value)
        },
    },
    props: {
        data: { type: Object, required: true },
        pacienteId: { type: Number, required: true },
    },
}
</script>